/**
 * @file
 * filters script.
 */

(function filtersScript($, Drupal) {
  'use strict';
  Drupal.behaviors.filters = {

    autosubmit: function () {
      // Autosubmit on each select option change.
      if ($('form.js-autosubmit').length > 0) {
        $('input.form-submit').trigger('click');
      }
    },
    attach: function (context) {
      var that = this;

      $('.filters select[multiple]').each(function () {
        var $select = $(this);
        var placeholder = $(this).attr('placeholder');

        if (typeof placeholder === 'undefined' || placeholder === null) {
          placeholder = Drupal.t('Select');

        }
        var $selected_item = $select.parent().find('li.selected');
        if ($selected_item.length > 0) {
          $select.parent().find('.form-select').addClass('has-selected-options');
        }

        $select
          .select2({
            placeholder: placeholder
          })
          .on('select2:open', function () {
            $select.parent().addClass('select-toggle--open');
          })
          .on('select2:close', function () {
            $select.parent().removeClass('select-toggle--open');
          })
          .on('change.select2', function () {
            that.autosubmit();
          });
      });
    }
  };

  Drupal.behaviors.CSHSFilterLabel = {
    attach: function (context) {
      $('select.simpler-select [data-parent-value="All"]').text('Filter By');
    }
  };

}(jQuery, Drupal));
